/**全局组件导入，请勿手动修改本文件。本文件由build/gen.js自动生成*/
import Vue from 'vue'
/** 全局组件注册:S */
import BottomAction from '@/components/common/BottomAction'
import Box from '@/components/common/Box'
import CheckboxButton from '@/components/common/CheckboxButton'
import Dialog from '@/components/common/Dialog'
import EmptyListTip from '@/components/common/EmptyListTip'
import Icon from '@/components/common/Icon'
import ListView from '@/components/common/ListView'
import fail from '@/components/common/Modal/fail'
import ModalMask from '@/components/common/Modal/ModalMask'
import PhoneModal from '@/components/common/Modal/PhoneModal'
import PrizeModal from '@/components/common/Modal/PrizeModal'
import Star from '@/components/common/Modal/Star'
import success from '@/components/common/Modal/success'
import tips from '@/components/common/Modal/tips'
import Nothing from '@/components/common/Nothing'
import PhoneSelector from '@/components/common/PhoneSelector'
import ProductItem from '@/components/common/ProductItem'
import SimplePicker from '@/components/common/SimplePicker'
import TabBar from '@/components/common/TabBar'
import TabPane from '@/components/common/TabPane'
import Tabs from '@/components/common/Tabs'
import TopCtrl from '@/components/common/TopCtrl'
import XInput from '@/components/common/XInput'

Vue.component('BottomAction', BottomAction)
Vue.component('Box', Box)
Vue.component('CheckboxButton', CheckboxButton)
Vue.component('Dialog', Dialog)
Vue.component('EmptyListTip', EmptyListTip)
Vue.component('Icon', Icon)
Vue.component('ListView', ListView)
Vue.component('fail', fail)
Vue.component('ModalMask', ModalMask)
Vue.component('PhoneModal', PhoneModal)
Vue.component('PrizeModal', PrizeModal)
Vue.component('Star', Star)
Vue.component('success', success)
Vue.component('tips', tips)
Vue.component('Nothing', Nothing)
Vue.component('PhoneSelector', PhoneSelector)
Vue.component('ProductItem', ProductItem)
Vue.component('SimplePicker', SimplePicker)
Vue.component('TabBar', TabBar)
Vue.component('TabPane', TabPane)
Vue.component('Tabs', Tabs)
Vue.component('TopCtrl', TopCtrl)
Vue.component('XInput', XInput)

/** 全局组件注册:E */


// WEBPACK FOOTER //
// ./src/CommonComponents.js